<template>
<tw-modal
        ref="modal"
    >
        <template v-slot:content>
            <div
                class="w-full px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4"
            >
                <div class="w-full sm:flex sm:items-start">
                    <svg xmlns="http://www.w3.org/2000/svg"
                        class="flex items-center justify-center flex-shrink-0 w-12 h-12 mx-auto text-blue-500 rounded-full sm:h-8 sm:mx-0 sm:w-8"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                    </svg>
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg font-medium leading-6 text-gray-900" id="modal-title">
                            {{ modalTitle }}
                        </h3>
                        <div class="mt-2">
                            <div class="mt-4">
                              <label for="name" class="block text-sm text-gray-500">Title</label>
                              <input type="text" name="name" v-model="form.title" id="name" class="block w-full min-w-0 border-gray-300 rounded-md sm:text-sm focus:ring-blue-500 focus:border-blue-500">
                                <label for="description" class="block text-sm text-gray-500">Description</label>
                                <div class="mt-1">
                                    <textarea v-model="form.description" rows="4" name="description" id="description" class="block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="flex justify-between px-4 py-3 space-x-2 sm:space-x-4 bg-gray-50 sm:px-6"
            >
                <a
                    class="tw-button-gray"
                    @click="closeModal"
                >{{ trans('app.cancel').titleCase() }}</a>
                <button
                    type="button"
                    class="tw-button-green space-x-1.5"
                    @click="submit"
                    :disabled="loading"
                >
                    <span>{{ trans('app.submit').titleCase() }}</span>
                    <svg
                        v-if="loading"
                        class="w-5 h-5 animate-spin"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                        </path>
                    </svg>
                </button>
            </div>
        </template>
    </tw-modal>
</template>

<script>
import Form from 'form-backend-validation';

export default {
  props: {
    projectId: {
      type: Number,
      required: false,
      default: () => null,
    },
  },

  data() {
    return {
      loading: false,
      project: null,
      projectUpdate: null,
      form: new Form({
        description: null,
        title: null,
        notify_account: null,
        related_type: null,
        related_id: null,
        project_id: null,
      }),
      config: {
        resetCss: true,
        autogrow: false,
      },
    };
  },

  computed: {
    type() {
      return 'project';
    },

    relatedId() {
      return this.projectId;
    },

    isProjectType() {
      return this.type === 'project';
    },

    isEdit() {
      return !_.isNull(this.projectUpdate);
    },

    modalTitle() {
      let lang_key = this.isEdit ? 'app.edit_this' : 'app.add_new_this';

      if (this.isProjectType) {
        return this.trans(lang_key, {
          this: this.transChoice('app.project_update', 1),
        }).titleCase();
      }

      return null;
    },

    storeUpdateRoute() {
      return this.isEdit
        ? this.route('project_updates.update', { id: this.projectUpdate.id })
        : this.route('project_updates.store');
    },
  },

  listeners: {
    async 'open-project-update-project-add-modal'(id = null) {
      this.form.related_id = this.relatedId;

      await this.showModal();
    },

    async 'open-project-update-project-edit-modal'(projectUpdate = null) {
      await this.showModal();

      if (!_.isNull(projectUpdate)) {
        this.setProjectUpdateForEdit(projectUpdate);
      }
    },
  },

  methods: {
    async showModal() {
      this.$refs.modal.show();
    },

    closeModal() {
      this.$refs.modal.hide();
      this.form.reset();
      this.projectUpdate = null;
    },

    async submit() {
      try {
        this.form.related_type = this.type;
        this.form.project_id = this.projectId;
        this.form.related_id = this.relatedId;

        await this.form.post(this.storeUpdateRoute);

        this.closeModal();
        OSPEvent.$emit('project-updates-updated', {});
      } catch (errors) {
        console.error(errors);
      }
    },

    setProjectUpdateForEdit(projectUpdate) {
      this.projectUpdate = projectUpdate;

      this.form.description = projectUpdate.description;
      this.form.title = projectUpdate.title;
      this.form.related_type = projectUpdate.related_type;
      this.form.related_id = this.relatedId;
    },
  },
};
</script>
